/*
 * dev (provider)
 */
import { useLocation, useNavigate } from "@tanstack/react-router"
import { useLocalStorage } from "@timeprox/react/hooks"
import { toast } from "@timeprox/react/ui"
import { Bug, SquareTerminal } from "lucide-react"
import { ReactNode } from "react"
import { DevContext } from "./dev.context"

type DevProviderProps = {
	children: ReactNode
}

export function DevProvider({ children }: DevProviderProps) {
	const location = useLocation()
	const navigate = useNavigate()

	const [devMode, setDevMode] = useLocalStorage("dev-mode", false)
	const [debugMode, setDebugMode] = useLocalStorage("debug-mode", false)

	function updateDevMode(newDevMode: boolean, showToast = true) {
		setDevMode(newDevMode)
		if (newDevMode) {
			if (showToast) {
				toast.success("Developer mode enabled", { icon: <SquareTerminal /> })
			}
		} else if (location.pathname === "/dev") {
			navigate("/" as any)
		}
	}
	function updateDebugMode(newDebugMode: boolean, showToast = true) {
		setDebugMode(newDebugMode)
		if (newDebugMode) {
			if (showToast) {
				toast.success("Debug mode enabled", { icon: <Bug /> })
			}
		}
	}

	return (
		<DevContext.Provider
			value={{
				debugMode,
				setDebugMode: updateDebugMode,
				devMode,
				setDevMode: updateDevMode,
			}}
		>
			{children}
		</DevContext.Provider>
	)
}
